import { FC } from 'react';
import ScanPageHeader from './header';
import HeaderTitle from './title';
import HeaderSteps from './steps';
import {
  ScanPageHeaderProps,
  ScanPageHeaderTitleProps,
  ScanPageHeaderStepsProps,
} from '../interface';

export type IScanPageHeaderComponent = FC<ScanPageHeaderProps> & {
  Title: FC<ScanPageHeaderTitleProps>;
  Steps: FC<ScanPageHeaderStepsProps>;
};

const TransScanPageHeader = ScanPageHeader as IScanPageHeaderComponent;
TransScanPageHeader.Title = HeaderTitle;
TransScanPageHeader.Steps = HeaderSteps;

export default TransScanPageHeader;